// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"3568c74c","95":"74efa5bf","172":"9cd4d687","402":"03991c37","419":"5d40ae12","453":"404938c1","525":"fade4643","818":"78f8f69d","881":"d1bd6779"}[chunkId] + ".chunk.js";
};